var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ColumnBaseSelectComponent } from '../base/columnbase-select.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { ConfigService } from '../../../service/config.service';
var SelectComponent = /** @class */ (function (_super) {
    __extends(SelectComponent, _super);
    function SelectComponent(service, baseService, cdRef, config) {
        var _this = _super.call(this, service, baseService, cdRef) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cdRef = cdRef;
        _this.config = config;
        _this.noInitSelect = false;
        _this.unselectedOption = new UnselectedOption();
        return _this;
    }
    SelectComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setValue();
    };
    SelectComponent.prototype.ngOnChanges = function (changes) {
        if ((changes.col || changes.msg) && this.col && this.msg) {
            this.setNoInitSelect();
            this.setUnselectedOption();
        }
        if (!this.changeValFlg) {
            this.setValue();
        }
        _super.prototype.ngOnChanges.call(this, changes);
    };
    SelectComponent.prototype.setNoInitSelect = function () {
        var noInitSelect = false;
        var key = (this.col.required ? 'required_no_init_select' : 'not_required_no_init_select');
        if (this.config.config[key]) {
            noInitSelect = (this.config.config[key] === 'true' ? true : false);
        }
        if (this.col.params && typeof this.col.params.noInitSelect !== 'undefined') {
            noInitSelect = this.col.params.noInitSelect;
        }
        this.noInitSelect = noInitSelect;
    };
    SelectComponent.prototype.setUnselectedOption = function () {
        var option = new UnselectedOption();
        var hiddenKey = (this.col.required === true ? 'required_unselected_option_hidden' : 'not_required_unselected_option_hidden');
        var displayKey = this.config.config['select_unselected_option_display'] || '';
        option.hidden = (this.col.required === true ? true : false);
        option.display = '';
        if (this.config.config[hiddenKey]) {
            option.hidden = (this.config.config[hiddenKey] === 'true' ? true : false);
        }
        if (displayKey && this.msg[displayKey]) {
            option.display = this.msg[displayKey];
        }
        if (this.col.params && this.col.params.unselectedOption) {
            option = Object.assign(option, this.col.params.unselectedOption);
        }
        this.unselectedOption = option;
    };
    SelectComponent.prototype.setValue = function () {
        if (typeof this.val === 'undefined' || this.val === null || this.val === '') {
            var options = (this.col.params && this.col.params.options ? this.col.params.options : []);
            if (options.length > 0 && this.unselectedOption.hidden) {
                this.val = options[0].code;
            }
            else {
                this.val = '';
            }
            if (this.noInitSelect === true) {
                this.val = null;
            }
            _super.prototype.onChange.call(this, this.val, false);
        }
        if (this.val !== null) {
            this.val = this.val.toString();
        }
    };
    SelectComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-select',
                    template: "<select name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" [(ngModel)]=\"val\" (change)=\"onChange(val)\" [key]=\"key\" [col]=\"col\" columnDir>\n  <option *ngIf=\"!unselectedOption.hidden\" value=\"\">{{ unselectedOption.display }}</option>\n  <option *ngFor=\"let option of col.params.options; trackBy: trackByOption\" [value]=\"option.code\">{{ option.display }}</option>\n</select>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    SelectComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ChangeDetectorRef },
        { type: ConfigService }
    ]; };
    return SelectComponent;
}(ColumnBaseSelectComponent));
export { SelectComponent };
var UnselectedOption = /** @class */ (function () {
    function UnselectedOption() {
    }
    return UnselectedOption;
}());
//# sourceMappingURL=select.component.js.map